// extracted by mini-css-extract-plugin
export var businessInfo = "footer-module--business-info--d0733";
export var businessName = "footer-module--business-name--38239";
export var container = "footer-module--container--3d4c5";